module.exports = __webpack_public_path__ + "static/img/M-6.fc2d061.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/myixuekao/M-6.png
// module id = 9tix
// module chunks = 0